module.exports = __webpack_public_path__ + "static/img/shuaxin.59461146.svg";